import { createIntlCache, createIntl } from '@formatjs/intl';
import { useState, useEffect, useMemo, useCallback } from 'react';
import '../contexts/MenuContext/index.mjs';
import { DEFAULT_LANGUAGE } from '../contexts/MenuContext/mapping.mjs';
import { useMenu } from '../contexts/MenuContext/context.mjs';
"use strict";
const useTranslationRaw = ({
  language,
  defaultTranslation,
  additionalTranslations
}) => {
  const [activeTranslation, setActiveTranslation] = useState(defaultTranslation);
  useEffect(() => {
    const loadTranslations = async () => {
      try {
        if (language === DEFAULT_LANGUAGE) {
          setActiveTranslation(defaultTranslation);
        } else {
          const translationsToLoad = additionalTranslations[language];
          if (translationsToLoad) {
            const loadedTranslations = await translationsToLoad();
            setActiveTranslation(loadedTranslations);
          }
        }
      } catch {
        console.error(`Failed to load translation ${language}`);
      }
    };
    loadTranslations();
  }, [language, additionalTranslations, defaultTranslation]);
  const intl = useMemo(() => {
    const cache = createIntlCache();
    return createIntl({
      locale: language,
      messages: activeTranslation
    }, cache);
  }, [language, activeTranslation]);
  const formatMessage = useCallback((id, values) => intl.formatMessage({
    id,
    defaultMessage: defaultTranslation[id]
  }, values), [intl, defaultTranslation]);
  return {
    intl,
    formatMessage
  };
};
const useTranslation = options => {
  const {
    language
  } = useMenu();
  const optionsExtended = useMemo(() => ({
    ...options,
    language
  }), [options, language]);
  return useTranslationRaw(optionsExtended);
};
export { useTranslation, useTranslationRaw };
//# sourceMappingURL=useTranslation.mjs.map
